__turbopack_context__.v({
  "card": "kqHxQa_card",
  "headerWrapper": "kqHxQa_headerWrapper",
  "reviewerInfoWrapper": "kqHxQa_reviewerInfoWrapper",
  "strongText": "kqHxQa_strongText",
  "translateButtonWrapper": "kqHxQa_translateButtonWrapper",
});
